<section class="withdrawal-details-card">
  <div class="d-flex flex-column gap-2">
    <div class="responsive-card-title" i18n>Withdrawal Details</div>
    <span class="description" i18n>
      The payments will be made with the withdrawal percentages outlined below. If one fund depletes its balance, the
      withdrawal instructions will convert entirely to the other fund.
    </span>
  </div>
  <div class="instructions-grid">
    <app-withdrawal-instructions-card
      *ngFor="let instruction of displayWithdrawalInstructions"
      [instruction]="instruction" />
  </div>
</section>
